import type React from "react";
import { createContext, useContext, useState, type ReactNode } from "react";

interface FilterContextType {
  startDate: string;
  endDate: string;
  type: string;
  searchQuery: string;
  setStartDate: (date: string) => void;
  setEndDate: (date: string) => void;
  setType: (type: string) => void;
  setSearchQuery: (query: string) => void;
  resetFilters: () => void;
  displayStartDate: string;
  displayEndDate: string;
}

const FilterContext = createContext<FilterContextType | undefined>(undefined);

interface FilterProviderProps {
  children: ReactNode;
}

export const FilterProvider: React.FC<FilterProviderProps> = ({ children }) => {
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [type, setType] = useState<string>("");
  const [searchQuery, setSearchQuery] = useState<string>("");


  const [displayStartDate, setDisplayStartDate] = useState<string>("");
  const [displayEndDate, setDisplayEndDate] = useState<string>("");

  const handleSetStartDate = (date: string) => {
    if (date) {
      setDisplayStartDate(date);

    
      if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = date.split("-");
        setStartDate(`${day}-${month}-${year}`);
      } else {
        setStartDate(date);
      }
    } else {
      setStartDate("");
      setDisplayStartDate("");
    }
  };

  const handleSetEndDate = (date: string) => {
    if (date) {
      setDisplayEndDate(date);

      if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = date.split("-");
        setEndDate(`${day}-${month}-${year}`);
      } else {
        setEndDate(date);
      }
    } else {
      setEndDate("");
      setDisplayEndDate("");
    }
  };

  const resetFilters = () => {
    setStartDate("");
    setEndDate("");
    setType("");
    setSearchQuery("");
    setDisplayStartDate("");
    setDisplayEndDate("");
  };

  const value = {
    startDate,
    endDate,
    type,
    searchQuery,
    setStartDate: handleSetStartDate,
    setEndDate: handleSetEndDate,
    setType,
    setSearchQuery,
    resetFilters,
    displayStartDate,
    displayEndDate,
  };

  return (
    <FilterContext.Provider value={value}>{children}</FilterContext.Provider>
  );
};

export const useFilter = (): FilterContextType => {
  const context = useContext(FilterContext);
  if (context === undefined) {
    throw new Error("useFilter must be used within a FilterProvider");
  }
  return context;
};
